module.exports = __webpack_public_path__ + "img/magnito.e6ad0ea6.png";